import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icone?: string;
  carregando?: boolean;
  cheio?: boolean;
  children: ReactNode;
}

// Botão secundário: branco, mesma altura e cantos do principal.
export default function SecondaryButton({
  icone,
  carregando = false,
  cheio = false,
  className = '',
  disabled,
  children,
  ...rest
}: SecondaryButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || carregando}
      className={`aperta inline-flex h-14 items-center justify-center gap-2 whitespace-nowrap rounded-[18px] border border-background-200 bg-background-50 px-6 text-[15px] font-semibold text-foreground-900 shadow-pcard transition-colors hover:bg-background-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:cursor-not-allowed disabled:opacity-60 ${
        cheio ? 'w-full' : ''
      } ${className}`}
      {...rest}
    >
      {carregando ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-loader-4-line animate-spin" aria-hidden />
        </span>
      ) : icone ? (
        <span className="flex h-5 w-5 items-center justify-center">
          <i className={icone} aria-hidden />
        </span>
      ) : null}
      {children}
    </button>
  );
}